import React, { useState } from 'react';
import '../../talukas/css/talukaManagement.css';
import BiddersTable from './BiddersTable';
import BidderFormModal from './BidderFormModal';
import { FaPlus } from 'react-icons/fa';
import { bidderAPI } from '../../../utils/api';

export default function BiddersManagement() {
  const [showModal, setShowModal] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  const save = async data => {
    if (editRow?.id) await bidderAPI.update(editRow.id, data);
    else await bidderAPI.create(data);
    setShowModal(false); setEditRow(null); setReloadKey(k => k + 1);
  };

  return (
    <div className="eduss-taluka-management">
      <div className="eduss-page-header">
        <div><h2>Qualified Bidders</h2><p>Validate or disqualify bidder records</p></div>
        <div className="eduss-dashboard-banner-date">{new Date().toLocaleDateString()}</div>
      </div>
      <div className="eduss-taluka-management-content-header" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <button className="eduss-global-table-btn add" onClick={() => { setEditRow(null); setShowModal(true); }}><FaPlus /> Add Bidder</button>
      </div>
      <div className="eduss-taluka-management-content">
        <BiddersTable key={reloadKey} onEdit={r => { setEditRow(r); setShowModal(true); }} />
      </div>
      <BidderFormModal open={showModal} initial={editRow} onClose={() => setShowModal(false)} onSave={save} />
    </div>
  );
}
